import { IS_PREVIEW } from '../share/constant';

declare let $load: (url: string) => Promise<void>;

export function removeStartSlash(url: string) {
  if (url.startsWith('#/')) {
    return url.substring(2);
  } else if (url.startsWith('/')) {
    return url.substring(1);
  } else {
    return url;
  }
}
export function addStartSlash(url: string) {
  return url.startsWith('/') ? url : `/${url}`;
}
/**
 * 处理路由路径，移除开头斜杠和查询参数部分
 * @param originRoute 原始路由路径字符串
 * @returns 处理后的纯路由路径（不包含开头斜杠和查询参数）
 */
export function transform2PureRoute(originRoute: string) {
  const url = decodeURIComponent(originRoute);
  const removeStartBackslashlineUrl = removeStartSlash(url);
  // 查找search起点的索引
  const searchIndex = removeStartBackslashlineUrl.indexOf('?');
  // 截取不包含search的url
  return searchIndex === -1 ? removeStartBackslashlineUrl : removeStartBackslashlineUrl.substring(0, searchIndex);
}

/**
 * 路由权限验证函数
 * 检查给定路由是否在允许的路由列表中，或处理特殊路由情况
 * @param route 要验证的路由字符串
 * @returns 布尔值，表示路由是否通过验证
 * @description
 * 1. 首先处理路由格式（去除开头的斜杠和查询参数）
 * 2. 检查全局MAX_ROUTES配置是否存在
 * 3. 处理特殊的lsub://协议路由
 * 4. 验证路由是否在允许的路由列表中
 * 5. 当MAX_ROUTES不存在时直接返回true（适用于生产环境）
 */
export function routeAuth(route: string) {
  // 检查全局路由配置是否存在
  if (globalThis.MAX_ROUTES && route) {
    // 处理路由格式：去除开头的斜杠并获取纯路径部分
    route = transform2PureRoute(route);
    const routes = Object.keys(globalThis.MAX_ROUTES);

    // 验证路由是否在允许的列表中
    if (!routes.includes(route)) {
      if (globalThis?.$routeAuth) globalThis.$routeAuth?.('undefined');
      return false;
    }
    return true;
  }

  // 当MAX_ROUTES不存在时（通常是生产环境构建产物），默认允许所有路由
  return true; // 产物
}

/**
 * 获取父页面路由
 * @param route
 * @returns
 */
export function getParentRoute(route: string) {
  if (route.startsWith('/')) {
    route = route.substring(1);
  }
  // 没有父路由，说明自己就是父路由
  if (route.indexOf('/') === -1) {
    return;
  }
  const routes = route.split('/');
  routes.pop();
  return routes.join('/');
}

/**
 * 构建标准化的路径名，确保URL以斜杠开头
 * @param url 输入的URL字符串
 * @returns 以斜杠开头的标准化路径名字符串
 */
export function buildPathname(url: string) {
  if (IS_PREVIEW) {
    // 目前IDE预览的iframe环境利用srcdoc属性直接消费了构建的html产物，与IDE非同源，所以在一些路由跳转操作中无法直接使用 history.pushState(state, '', url),浏览器基于安全会校验url是否同源。
    // 所以，迫使在使用 history.pushState(state, '', url) 和 history.replaceState(state, '', url)时，url必须为空字符串绕开同源校验。
    // ps: 如果iframe是利用src属性消费html产物的话就符合浏览器的安全校验了。
    return '';
  } else {
    return addStartSlash(url);
  }
}

/**
 * 是否顶层路由一致
 * @param last
 * @param next
 * @returns
 */
export function isSameDomain(last: string, next: string) {
  if (!last || !next) return false;
  return last.split('/')[0] === next.split('/')[0];
}

/**
 * 获取顶层路由
 * @param route
 * @returns
 */
export function getTopRoute(route: string) {
  if (route.startsWith('/')) {
    route = route.substring(1);
  }
  return route.split('/')[0];
}

/**
 * 获取资源
 * @param pageKey
 * @returns
 */
export function loadBuiltFile(path: string) {
  if (path.startsWith('/')) {
    path = path.substring(1);
  }
  return $load(path);
}

/**
 * 获取页面资源
 * @param pageCode
 * @returns
 */
export function loadPage(pageCode: string) {
  return loadBuiltFile(`dist/pages/${pageCode}.mjs`);
}

function hasSubArray(master: string[], sub: string[]) {
  return !master.some((val) => sub.indexOf(val) === -1);
}

export function isSubRoute(parent: string, sub: String) {
  const parents = parent.split('/');
  const subs = sub.split('/');
  return hasSubArray(parents, subs);
}

export function diffRoute(
  originRouteInfo: { url: string; params: any },
  targetRouteInfo: { url: string; params: any },
) {
  // 先判断url是否一致
  if (removeStartSlash(originRouteInfo.url) !== removeStartSlash(targetRouteInfo.url)) {
    return false;
  }
  // 再判断params是否一致
  if (typeof originRouteInfo.params !== typeof targetRouteInfo.params) {
    return false;
  }
  if (JSON.stringify(originRouteInfo.params) !== JSON.stringify(targetRouteInfo.params)) {
    return false;
  }
  return true;
}
